var map = {
	"./skins/IBC-dyst": [
		193,
		18
	],
	"./skins/IBC-dyst-2025": [
		192,
		19
	],
	"./skins/IBC-dyst-2025.css": [
		558,
		41
	],
	"./skins/IBC-dyst-2025.js": [
		192,
		19
	],
	"./skins/IBC-dyst.css": [
		559,
		40
	],
	"./skins/IBC-dyst.js": [
		193,
		18
	],
	"./skins/aktionaerliga-2024": [
		194,
		17
	],
	"./skins/aktionaerliga-2024.css": [
		560,
		39
	],
	"./skins/aktionaerliga-2024.js": [
		194,
		17
	],
	"./skins/aktionaerliga-2025": [
		195,
		16
	],
	"./skins/aktionaerliga-2025.css": [
		561,
		38
	],
	"./skins/aktionaerliga-2025.js": [
		195,
		16
	],
	"./skins/bibliotekarernes-sep-2024": [
		196,
		15
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		562,
		37
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		196,
		15
	],
	"./skins/boersen-spiel-sep-2024": [
		197,
		14
	],
	"./skins/boersen-spiel-sep-2024.css": [
		563,
		36
	],
	"./skins/boersen-spiel-sep-2024.js": [
		197,
		14
	],
	"./skins/borsgruppenliu-jan-2024": [
		198,
		13
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		564,
		35
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		198,
		13
	],
	"./skins/fynske-bank-sep-2024": [
		199,
		12
	],
	"./skins/fynske-bank-sep-2024.css": [
		565,
		34
	],
	"./skins/fynske-bank-sep-2024.js": [
		199,
		12
	],
	"./skins/ibc-jan-2024": [
		200,
		20
	],
	"./skins/ibc-jan-2024.js": [
		200,
		20
	],
	"./skins/sdu-businessschooldays-2024": [
		201,
		11
	],
	"./skins/sdu-businessschooldays-2024.css": [
		566,
		33
	],
	"./skins/sdu-businessschooldays-2024.js": [
		201,
		11
	],
	"./skins/sdu-businessschooldays-2025": [
		202,
		10
	],
	"./skins/sdu-businessschooldays-2025.css": [
		567,
		32
	],
	"./skins/sdu-businessschooldays-2025.js": [
		202,
		10
	],
	"./skins/skoledyst-oct-2023": [
		203,
		9
	],
	"./skins/skoledyst-oct-2023.css": [
		568,
		31
	],
	"./skins/skoledyst-oct-2023.js": [
		203,
		9
	],
	"./skins/skolernes-aktiedyst-2024": [
		204,
		8
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		569,
		30
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		204,
		8
	],
	"./skins/skolernes-aktiedyst-2025": [
		205,
		7
	],
	"./skins/skolernes-aktiedyst-2025.css": [
		570,
		29
	],
	"./skins/skolernes-aktiedyst-2025.js": [
		205,
		7
	],
	"./skins/sommerdysten-ad-2023": [
		206,
		6
	],
	"./skins/sommerdysten-ad-2023.css": [
		571,
		28
	],
	"./skins/sommerdysten-ad-2023.js": [
		206,
		6
	],
	"./skins/sommerdysten-ak-2023": [
		207,
		5
	],
	"./skins/sommerdysten-ak-2023.css": [
		572,
		27
	],
	"./skins/sommerdysten-ak-2023.js": [
		207,
		5
	],
	"./skins/sommerdysten-is-2023": [
		208,
		4
	],
	"./skins/sommerdysten-is-2023.css": [
		573,
		26
	],
	"./skins/sommerdysten-is-2023.js": [
		208,
		4
	],
	"./skins/sydbank-sep-2020": [
		209,
		3
	],
	"./skins/sydbank-sep-2020.css": [
		574,
		25
	],
	"./skins/sydbank-sep-2020.js": [
		209,
		3
	],
	"./skins/targo-2025": [
		210,
		2
	],
	"./skins/targo-2025.css": [
		575,
		24
	],
	"./skins/targo-2025.js": [
		210,
		2
	],
	"./skins/ung_aktiedyst_2025": [
		211,
		1
	],
	"./skins/ung_aktiedyst_2025.css": [
		576,
		23
	],
	"./skins/ung_aktiedyst_2025.js": [
		211,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		212,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		577,
		22
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		212,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 357;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 357
// module chunks = 42